import client from "graphql/client";
import i18next from "i18next";
import { loader } from "graphql.macro";
import { BOOKS_PUBLISHED_LOADED } from "redux/types";
import { snackbarError } from "shared/redux/actions/Snackbar";

const fetchBooks = loader("shared/graphql/queries/books/fetchBooks.graphql");

export function booksLoadPublished() {
    return async (dispatch, getState) => {
        const { current: organisation } = getState().organisation;
        
        try {
            await client.query({
                query: fetchBooks,
                variables: { organisationId: organisation.id },
                fetchPolicy: "network-only"
            }).then(({ data }) => {
                const { books } = data;
                const booksMapped = {};

                books.forEach((book) => {
                    const measures  = JSON.parse(book.measures);
                    const chapters = JSON.parse(book.chapters);
                    const measureKeys = Object.keys(measures);
                    const chapterKeys = Object.keys(chapters);

                    measureKeys.forEach((key)=> {
                        measures[key].id = key;
                    });
                    chapterKeys.forEach((key)=> {
                        chapters[key].id = key;
                    });

                    booksMapped[book.osbn] = {
                        ...book,
                        measures,
                        chapters
                    };
                });

                dispatch({
                    type: BOOKS_PUBLISHED_LOADED,
                    books: booksMapped
                });
            });

        } catch (error) {
            console.error(error);
            dispatch(snackbarError(i18next.t("books.loading.failed")));
        }
    };
}